import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { Importer } from '@feathr/blackbox';
import ProgressCell from '@feathr/extender/components/ProgressCell';

import { getImportProgressMode } from './ImportProgressCell.utils';

interface IImportProgressCellProps {
  importer: Importer;
}

function ImportProgressCell({ importer }: Readonly<IImportProgressCellProps>): JSX.Element {
  const { t } = useTranslation();
  const mode = getImportProgressMode({
    state: importer.get('state'),
    progress: importer.get('progress'),
  });

  return <ProgressCell label={t('Import progress')} mode={mode} />;
}

export default observer(ImportProgressCell);
